import AddStore from './AddStore';
import { useParams } from 'react-router-dom';

const AddStoreForMerchant: React.FC = () => {
  const { id } = useParams();

  return <AddStore merchantId={id} />;
};

export default AddStoreForMerchant;
